import React, {Component} from 'react'
import MacGenerateServiceID from './MacGenerateServiceID'
import MacGenerateServiceName from './MacGenerateServiceName'
import MacGenerateGroupName from './MacGenerateGroupName'
import MacServiceConfirmation from './MacServiceConfirmation'

export default class MacServiceManagement extends Component {

    state = {
        step: 1,
        email: '',
        username: '',
        password: '',
        firstName: '',
        lastName: '',
        country: '',
        levelOfEducation: '',
    }

    // go back to previous step
    prevStep = () => {
        const { step } = this.state;
        this.setState({ step: step - 1 });
    }

    // proceed to the next step
    nextStep = () => {
        const { step } = this.state;
        this.setState({ step: step + 1 });
    }

    // Handle fields change
    handleChange = input => e => {
        this.setState({ [input]: e.target.value });
    }

    render() {
        const { step } = this.state;
        const { email, username, password, firstName, lastName, country, levelOfEducation } = this.state;
        const values = { email, username, password, firstName, lastName, country, levelOfEducation }

        switch(step) {
            case 1:
                return (
                    <MacGenerateServiceID
                        nextStep={ this.nextStep }
                        handleChange={ this.handleChange }
                        values={ values }
                    />
                )
            case 2:
                return (
                    <MacGenerateServiceName
                        prevStep={ this.prevStep }
                        nextStep={ this.nextStep }
                        handleChange={ this.handleChange }
                        values={ values }
                    />
                )
            case 3:
                return (
                    <MacGenerateGroupName
                        prevStep={ this.prevStep }
                        nextStep={ this.nextStep }
                        handleChange={ this.handleChange }
                        values={ values }
                    />

                )
            case 4:
                return (
                    <MacServiceConfirmation
                        values={ values }
                    />
                )

            default:

            // do nothing
        }
    }
}